module.exports = __webpack_public_path__ + "static/entityframework-aa2ed5ce849cc46e3cbddfa761201b7b.png";